import { AxiosInstance } from 'axios';
import { Role } from 'enum/roles';
import { BaseApi } from 'services/api/base-api';
import { UserSummary } from 'services/api/models';
import { ApiResult } from 'services/api/result.type';
import {
  ListUsersResponse,
  FindUserByEmailResponse,
  UpdateUserRequest,
} from './dto';
import { FindUserForApprovalResponse } from './dto/find-user-for-approval.dto';

export class UsersApi extends BaseApi {
  public constructor (protected readonly api: AxiosInstance) {
    super();

    this.getUsers = this.getUsers.bind(this);
    this.exportUsers = this.exportUsers.bind(this);
    this.findByEmail = this.findByEmail.bind(this);
    this.getById = this.getById.bind(this);
    this.updateUser = this.updateUser.bind(this);
  }

  public async getUsers ({
    page,
    search,
    roles,
    rosterFilter,
    showFacilityManagers,
  }: {
    page?: number;
    search: string | null;
    roles?: Role[];
    rosterFilter?: 'leader' | 'member';
    showFacilityManagers?: boolean;
  }): ApiResult<ListUsersResponse> {
    return await this.get<ListUsersResponse>('/users', {
      params: { page, search, roles, rosterFilter, showFacilityManagers },
    });
  }

  public async exportUsers ({
    search,
    roles,
    rosterFilter,
  }: {
    search?: string | null;
    roles?: Role[];
    rosterFilter?: 'leader' | 'member';
  }): ApiResult<any> {
    return await this.get('/users/export', {
      params: { search, roles, rosterFilter },
      responseType: 'blob',
    });
  }

  public async findByEmail (email: string): ApiResult<FindUserByEmailResponse> {
    return await this.get<FindUserByEmailResponse>(`/users/email/${email}`);
  }

  public async getById (id: string, schoolId?: string): ApiResult<UserSummary> {
    const query = schoolId ? `?schoolId=${schoolId}` : '';
    return await this.get<UserSummary>(`/users/${id}${query}`);
  }

  public async updateUser (
    id: string,
    data: UpdateUserRequest,
  ): ApiResult<void> {
    return await this.patch<void>(`/users/${id}`, data);
  }

  public async findUserForApprovalSequence (
    email: string,
    schoolId: string,
  ): ApiResult<FindUserForApprovalResponse> {
    return await this.get<FindUserForApprovalResponse>('/users/find-for-approval', {
      params: { email, schoolId },
    });
  }
}
